module.exports = __webpack_public_path__ + "img/icon-add-blue-hover.ffda588c.svg";